/**
 * Os diálogos da experiência de uso, montados UMA vez no layout do workspace. Qualquer
 * tela abre um deles por `useExperience().openDialog(...)`.
 */
import type { WorkspaceRole } from '@mgdlead/shared';

import { CommandPaletteHost } from './CommandPaletteHost';
import { FeedbackDialog } from './FeedbackDialog';
import { NewsDrawer } from './NewsDrawer';
import { ShortcutsDialog } from './ShortcutsDialog';
import { useExperience } from './ExperienceProvider';

export function ExperienceChrome({
  workspaceId,
  slug,
  role,
}: {
  workspaceId: string;
  slug: string;
  role: WorkspaceRole;
}) {
  const { dialog, openDialog, closeDialog, npsDue, markNewsSeen } = useExperience();
  const setOpen = (name: 'shortcuts' | 'feedback' | 'news') => (next: boolean) =>
    next ? openDialog(name) : closeDialog();

  return (
    <>
      <CommandPaletteHost workspaceId={workspaceId} slug={slug} role={role} />
      <ShortcutsDialog open={dialog === 'shortcuts'} onOpenChange={setOpen('shortcuts')} />
      <FeedbackDialog
        open={dialog === 'feedback'}
        onOpenChange={setOpen('feedback')}
        workspaceId={workspaceId}
        npsDue={npsDue}
      />
      <NewsDrawer
        open={dialog === 'news'}
        onOpenChange={setOpen('news')}
        onSeen={markNewsSeen}
        slug={slug}
      />
    </>
  );
}
